import { Input } from '@shared/ui'
import { useFormContext } from 'react-hook-form'
import {
  errorSpanClassName,
  inputClassName,
  selectErrorClassName,
  axisInputClassName,
} from '../styles'
import { FC } from 'react'
import { DS_TYPOGRAPHY_BODY_SM_REGULAR } from '@shared/ui'

type SRInputProps = {
  children?: unknown
  id?: string
  value?: string
  defaultValue?: string
  placeholder?: string
  name?: string | undefined
  type?: string
  min?: number
  max?: number
  disabled?: boolean
  className?: string
  isAxis?: boolean
}

export const SRInput: FC<SRInputProps> = ({
  children,
  id,
  value,
  defaultValue,
  placeholder,
  name= '',
  type = 'text',
  min,
  max,
  disabled,
  className = '',
  isAxis = false,
}) => {
  const {
    formState: { errors },
  } = useFormContext()

  const hasError = errors[name]
  const errorMessage = errors[name]?.message?.toString()

  return (
    <div
      className={`flex flex-col ${className} ${
        disabled ? 'cursor-not-allowed' : ''
      } `}
    >
      <Input
        className={`${inputClassName} ${isAxis ? `${DS_TYPOGRAPHY_BODY_SM_REGULAR} ${axisInputClassName}` : ''} ${hasError ? selectErrorClassName : ''} ${
          disabled ? 'pointer-events-none  opacity-75' : ''
        }`}
        name={name}
        type={type}
        id={id}
        placeholder={placeholder}
        defaultValue={defaultValue}
        value={value}
        min={min}
        max={max}
      >
        {children}
      </Input>
      {hasError && (
        <span className={`${errorSpanClassName} max-w-[280px]`}>
          * {errorMessage}
        </span>
      )}
    </div>
  )
}
